export default {
  init() {
  },
  finalize() {
    // var homeHeader = $('.home-header');
    // $('head').append('<style>div.home-header:before{height:' + (homeHeader.height() - 165) + 'px !important;}</style>');
  },
};



// WEBPACK FOOTER //
// resources/assets/scripts/routes/home.js